export default __webpack_public_path__ + "static/media/mazaikad.0d296157.gif";